module.exports = __webpack_public_path__ + "media/images/crunchBase-06da13436b9bb66dc946d103177d1bd0.png";